export const PRESCRIPTION_STATUS = {
  NEW: 'new',
  STARTED: 'started',
  EXPIRED: 'expired',
};

export const NOT_STARTED_PRESCRIPTION = 'Not Started';
export const REDEEMED_NOT_STARTED_PRESCRIPTION = 'Redeemed (Not Started)';

export const isExpiredStatus = (prescription: IPrescription): boolean => {
  const { startDateWithTimezone, endDateWithTimezone, status } = prescription;
  return Boolean(
    startDateWithTimezone &&
      endDateWithTimezone &&
      status === PRESCRIPTION_STATUS.EXPIRED,
  );
};

export const isActiveStatus = (prescription: IPrescription): boolean => {
  const { startDateWithTimezone, status } = prescription;
  return Boolean(
    startDateWithTimezone && status === PRESCRIPTION_STATUS.STARTED,
  );
};

export const isNotStartedStatus = (prescription: IPrescription): boolean =>
  !isExpiredStatus(prescription) && !isActiveStatus(prescription);
